// Approximate city-center coordinates (lat, lon) for slugs in lib/cities.js.
// Used to query nearby charging stations on the "recharge VSP" pages.
// Dependency-free so the prerender script can load it too.
export const CITY_COORDS = {
  paris: { lat: 48.8566, lon: 2.3522 },
  lyon: { lat: 45.764, lon: 4.8357 },
  marseille: { lat: 43.2965, lon: 5.3698 },
  toulouse: { lat: 43.6047, lon: 1.4442 },
  bordeaux: { lat: 44.8378, lon: -0.5792 },
  nantes: { lat: 47.2184, lon: -1.5536 },
  rennes: { lat: 48.1173, lon: -1.6778 },
  nice: { lat: 43.7102, lon: 7.262 },
  lille: { lat: 50.6292, lon: 3.0573 },
  strasbourg: { lat: 48.5734, lon: 7.7521 },
  montpellier: { lat: 43.6108, lon: 3.8767 },
  reims: { lat: 49.2583, lon: 4.0317 },
  "le-havre": { lat: 49.4944, lon: 0.1079 },
  "saint-etienne": { lat: 45.4397, lon: 4.3872 },
  toulon: { lat: 43.1242, lon: 5.928 },
  grenoble: { lat: 45.1885, lon: 5.7245 },
  dijon: { lat: 47.322, lon: 5.0415 },
  angers: { lat: 47.4784, lon: -0.5632 },
  nimes: { lat: 43.8367, lon: 4.3601 },
  "clermont-ferrand": { lat: 45.7772, lon: 3.087 },
  "le-mans": { lat: 48.0061, lon: 0.1996 },
  "aix-en-provence": { lat: 43.5297, lon: 5.4474 },
  brest: { lat: 48.3904, lon: -4.4861 },
  tours: { lat: 47.3941, lon: 0.6848 },
  amiens: { lat: 49.8941, lon: 2.2958 },
  limoges: { lat: 45.8336, lon: 1.2611 },
  annecy: { lat: 45.8992, lon: 6.1294 },
  perpignan: { lat: 42.6887, lon: 2.8948 },
  besancon: { lat: 47.2378, lon: 6.0241 },
  metz: { lat: 49.1193, lon: 6.1757 },
  orleans: { lat: 47.9029, lon: 1.9093 },
  rouen: { lat: 49.4432, lon: 1.0993 },
  mulhouse: { lat: 47.7508, lon: 7.3359 },
  caen: { lat: 49.1829, lon: -0.3707 },
  nancy: { lat: 48.6921, lon: 6.1844 },
  avignon: { lat: 43.9493, lon: 4.8055 },
  pau: { lat: 43.2951, lon: -0.3708 },
  "la-rochelle": { lat: 46.1603, lon: -1.1511 },
  chambery: { lat: 45.5646, lon: 5.9178 },
  valence: { lat: 44.9334, lon: 4.8924 },
  lorient: { lat: 47.7477, lon: -3.366 },
  quimper: { lat: 47.996, lon: -4.0978 },
  bayonne: { lat: 43.4929, lon: -1.4748 },
  beziers: { lat: 43.3442, lon: 3.216 },
  troyes: { lat: 48.2973, lon: 4.0744 },
  niort: { lat: 46.3239, lon: -0.4588 },
  cholet: { lat: 47.0594, lon: -0.8787 },
  vannes: { lat: 47.6582, lon: -2.7608 },
  "la-roche-sur-yon": { lat: 46.6705, lon: -1.4269 },
  angouleme: { lat: 45.6484, lon: 0.1562 },
  chartres: { lat: 48.444, lon: 1.489 },
  colmar: { lat: 48.0794, lon: 7.3585 },
  bourges: { lat: 47.081, lon: 2.3987 },
  montauban: { lat: 44.0179, lon: 1.3549 },
  poitiers: { lat: 46.5802, lon: 0.3404 },
  "saint-nazaire": { lat: 47.2735, lon: -2.2135 },
  valenciennes: { lat: 50.358, lon: 3.5233 },
  dunkerque: { lat: 51.0343, lon: 2.3768 },
  calais: { lat: 50.9513, lon: 1.8587 },
  "boulogne-sur-mer": { lat: 50.7264, lon: 1.6147 },
  arras: { lat: 50.291, lon: 2.7772 },
  beauvais: { lat: 49.4294, lon: 2.0809 },
  compiegne: { lat: 49.4179, lon: 2.8261 },
  evreux: { lat: 49.027, lon: 1.1508 },
  cherbourg: { lat: 49.6337, lon: -1.6221 },
  "saint-brieuc": { lat: 48.5144, lon: -2.7653 },
  laval: { lat: 48.0698, lon: -0.77 },
  belfort: { lat: 47.6379, lon: 6.8628 },
  "chalon-sur-saone": { lat: 46.7806, lon: 4.8537 },
  roanne: { lat: 46.034, lon: 4.0686 },
  montlucon: { lat: 46.3408, lon: 2.6033 },
  nevers: { lat: 46.9896, lon: 3.1573 },
  auxerre: { lat: 47.7982, lon: 3.5673 },
  tarbes: { lat: 43.2328, lon: 0.0782 },
  albi: { lat: 43.9289, lon: 2.1479 },
  carcassonne: { lat: 43.213, lon: 2.3491 },
  narbonne: { lat: 43.1839, lon: 3.0036 },
  agen: { lat: 44.2049, lon: 0.6212 },
  "saint-quentin": { lat: 49.8489, lon: 3.2876 },
  melun: { lat: 48.5416, lon: 2.6601 },
  meaux: { lat: 48.9602, lon: 2.8782 },
  nanterre: { lat: 48.8924, lon: 2.2068 },
  "boulogne-billancourt": { lat: 48.8352, lon: 2.2409 },
  montreuil: { lat: 48.8638, lon: 2.4485 },
  "saint-denis": { lat: 48.9362, lon: 2.3574 },
  versailles: { lat: 48.8049, lon: 2.1204 },
  creteil: { lat: 48.7904, lon: 2.4556 },
  argenteuil: { lat: 48.9472, lon: 2.2467 },
  cergy: { lat: 49.0361, lon: 2.0631 },
  "evry-courcouronnes": { lat: 48.6239, lon: 2.429 },
};

export const CHARGING_PATH = "/recharge-voiture-sans-permis";

export function cityCoords(slug) {
  return CITY_COORDS[slug] || null;
}

// Nearest cities (by great-circle distance) to a given city slug. Returns an
// array of slugs, closest first. Used for internal linking ("villes proches").
export function nearbyCities(slug, n) {
  const here = CITY_COORDS[slug];
  if (!here) return [];
  const toRad = (d) => (d * Math.PI) / 180;
  const dist = (a, b) => {
    const R = 6371;
    const dLat = toRad(b.lat - a.lat);
    const dLon = toRad(b.lon - a.lon);
    const s =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLon / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(s));
  };
  return Object.keys(CITY_COORDS)
    .filter((s) => s !== slug)
    .map((s) => ({ slug: s, d: dist(here, CITY_COORDS[s]) }))
    .sort((a, b) => a.d - b.d)
    .slice(0, n || 6)
    .map((x) => x.slug);
}
